import styled from 'styled-components';

import { alignItems, flexDirection, flexGrow, flexbox, inlineFlexbox, justifyContent } from '@styles/helpers/flexbox';

import { widthFillAvailable } from '@styles/helpers/common';

import ThemeHelper from '@themes/theme-helper';

export const ModalBody = styled.div((props) => {
  const { palette } = ThemeHelper.getTheme(props);

  return `
    ${flexbox()};
    ${flexDirection('column')};
    ${alignItems('center')};

    min-width: 450px;
    min-height: 400px;

    color: ${palette.primary.dark};
  `;
});

export const StudentDetails = styled.div`
  ${justifyContent('center')};
  ${flexDirection('column')};

  margin-bottom: 10px;
  user-select: none;
`;

export const StudentName = styled.div`
  font-size: 21px;
  font-weight: bold;
  line-height: 31px;
`;

export const CourseDetails = styled.div`
  ${inlineFlexbox()};
  font-size: 16px;
  line-height: 25px;
  margin: 0 10px;
`;

export const AssignedWrapper = styled.div((props) => {
  const { typography } = ThemeHelper.getTheme(props);

  return `
    ${flexbox()}
    ${flexDirection('column')}

    position: -webkit-sticky;
    position: sticky;
    left: 0;
    width: auto;
    height: 100%;
    font-size: 14px;
    font-family: ${typography.family};
`;
});

export const TabHeading = styled.div((props) => {
  const { colours, palette } = ThemeHelper.getTheme(props);

  return `
    ${inlineFlexbox()};
    ${justifyContent('center')};
    ${alignItems('center')};
    
    z-index: 2;
    padding: 5px 10px;
    box-sizing: border-box;
    height: 35px;
    min-width: 125px;
    font-size: 16px;

    background-color: ${palette.primary.text};
    border: 1px solid ${colours.grey[400]};
    border-bottom: none;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;

    div[class*='svgIconComponent--'] {
      width: auto;
      margin-right: 5px;
      
      path {
        fill: #3C4E5E;
      }
    }
  `;
});

export const ResultsWrapper = styled.div((props) => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
    ${flexbox()};
    ${alignItems('center')};
    ${flexDirection('column')}
    ${flexGrow('1')}
    ${widthFillAvailable()}
  
    margin-top: -1px;
    border: 1px solid ${colours.grey[300]};
    border-radius: 15px;
    padding: 25px 10px 10px 20px;
    min-height: 0;
  `;
});

export const Footer = styled.div`
  ${flexbox()}
  ${justifyContent('space-between')}
  
  margin-top: 10px;
  width: 100%;

  div {
    width: 120px;
  }
`;
